export default __webpack_public_path__ + "static/media/jukin-media-logo-fb.47bca818.png";